import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await authAPI.getCurrentUser();
        setUser(response.data);
      } catch (error) {
        // Clear auth data on invalid/expired token
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
    setLoading(false);
  };

  const login = async (email, password, mfaCode = null) => {
    const payload = { email, password };
    if (mfaCode) payload.mfa_code = mfaCode;
    const response = await authAPI.login(payload);
    const { access_token } = response.data;
    localStorage.setItem('token', access_token);
    const profileResponse = await authAPI.getCurrentUser();
    setUser(profileResponse.data);
    return profileResponse.data;
  };

  const register = async (data) => {
    await authAPI.register(data);
    // New accounts require admin approval; do not log in automatically
    return null;
  };

  const logout = () => {
    // Clear all auth data to prevent token leakage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  const updateUser = (updatedUser) => {
    setUser(updatedUser);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
};